var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / chevron down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.205 4.82999C8.41594 4.61931 8.70187 4.50098 9 4.50098C9.29812 4.50098 9.58406 4.61931 9.795 4.82999L16.17 11.205C16.3807 11.4159 16.499 11.7019 16.499 12C16.499 12.2981 16.3807 12.584 16.17 12.795L9.795 19.17C9.6906 19.2744 9.56666 19.3572 9.43025 19.4137C9.29384 19.4702 9.14764 19.4993 9 19.4993C8.85235 19.4993 8.70615 19.4702 8.56975 19.4137C8.43334 19.3572 8.3094 19.2744 8.205 19.17C8.1006 19.0656 8.01778 18.9416 7.96128 18.8052C7.90478 18.6688 7.8757 18.5226 7.8757 18.375C7.8757 18.2273 7.90478 18.0811 7.96128 17.9447C8.01778 17.8083 8.1006 17.6844 8.205 17.58L13.7835 12L8.205 6.41999C7.99432 6.20905 7.87599 5.92311 7.87599 5.62499C7.87599 5.32686 7.99432 5.04092 8.205 4.82999Z",
    fill: "#919191"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default __webpack_public_path__ + "static/media/icon-chevron-right.b6d9c693484531b5eb995fe20d61e27a.svg";
export { ForwardRef as ReactComponent };